import { useResponsive } from '@/hooks/use-responsive';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { Loader } from './loader';

interface StickyTableLoaderProps {
  size?: number;
  className?: string;
  loaderColor?: string;
  forceRecalculateTopPosition?: any; // Optional prop to force recalculation
}

export const StickyTableLoader = ({ size, className, loaderColor, forceRecalculateTopPosition }: StickyTableLoaderProps) => {
  const { isTablet, isDesktop, isLargeDesktop } = useResponsive();

  const [topPosition, setTopPosition] = useState(0);

  useEffect(() => {
    const updateTopPosition = () => {
      const filterPageElement = document.getElementById('table-filters');
      const tableHeaderElement = document.getElementById('table-header');

      if (filterPageElement || tableHeaderElement) {
        const filterPageHeight = filterPageElement?.offsetHeight || 0;
        const tableHeaderHeight = tableHeaderElement?.offsetHeight || 0;
        setTopPosition(filterPageHeight + tableHeaderHeight);
      }
    };

    // Execute immediately
    updateTopPosition();

    // Execute again after one second
    setTimeout(updateTopPosition, 1000);
  }, [isTablet, isDesktop, isLargeDesktop, forceRecalculateTopPosition]);

  return (
    <StickyLoaderWrapper top={`${topPosition}px`}>
      <Loader size={size} className={className} loaderColor={loaderColor} />
    </StickyLoaderWrapper>
  );
};

export const StickyLoaderWrapper = styled.div<{ top: string }>`
  position: sticky;
  top: ${({ top }) => top};
  z-index: 9;
`;
